import { Clock3, Send, ShieldAlert } from 'lucide-react';

export function P2PTimeCompressionOverlay({ patientName }: { patientName: string }) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-background/90 p-4 backdrop-blur-sm motion-safe:animate-in motion-safe:fade-in"
      role="status"
      aria-live="polite"
    >
      <div className="w-full max-w-md rounded-lg border border-border bg-card p-6 shadow-lg">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-md border border-primary/20 bg-primary/10 text-primary">
            <Send className="h-5 w-5" />
          </div>
          <div>
            <p className="text-sm font-semibold text-foreground">Authorization submitted</p>
            <p className="mt-1 text-xs text-muted-foreground">{patientName} · secure demo handoff complete</p>
          </div>
        </div>

        <div className="my-5 flex items-center gap-3" aria-hidden="true">
          <div className="h-px flex-1 bg-border" />
          <div className="flex items-center gap-2 text-xs font-medium text-muted-foreground">
            <Clock3 className="h-4 w-4" />
            48 hours later
          </div>
          <div className="h-px flex-1 bg-border" />
        </div>

        <div className="flex items-center gap-3 rounded-md border border-amber-300/70 bg-amber-50 p-4 text-amber-950">
          <ShieldAlert className="h-5 w-5 shrink-0 text-amber-700" />
          <div>
            <p className="text-sm font-semibold">Payer response received</p>
            <p className="mt-1 text-xs leading-5 text-amber-900/80">
              LINK is normalizing the denial and preparing the P2P pathway.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
